import { GoogleGenAI } from '@google/genai';

class GeminiService {
  private getAI() {
    const apiKey = process.env.GEMINI_API_KEY || 
                   process.env.API_KEY || 
                   (import.meta.env?.VITE_GEMINI_API_KEY as string) || 
                   (import.meta.env?.VITE_API_KEY as string);
    return new GoogleGenAI({ apiKey });
  }

  async analyzePlantImage(imageBase64: string): Promise<{ text: string; sources?: { uri: string; title: string }[] }> {
    const ai = this.getAI();
    const imagePart = {
      inlineData: {
        mimeType: imageBase64.match(/data:(.*?);/)?.[1] || 'image/webp',
        data: imageBase64.split(',')[1],
      },
    };
    const textPart = {
      text: "Identifique esta planta e analise seu estado de saúde. Forneça detalhes sobre a espécie, cuidados recomendados e qualquer sinal de doença ou praga.",
    };
    
    try {
      const response = await ai.models.generateContent({
        model: 'gemini-1.5-pro',
        contents: { parts: [imagePart, textPart] },
        config: {
          tools: [{ googleSearch: {} }],
        },
      });

      console.log("[Gemini Service - analyzePlantImage] Resposta bruta da IA:", JSON.stringify(response, null, 2));

      let groundingChunks: any[] = [];
      try {
        groundingChunks = response.candidates?.[0]?.groundingMetadata?.groundingChunks || [];
        console.log("[Gemini Service - analyzePlantImage] Grounding recebido (parsed):", groundingChunks);
        
        if (!groundingChunks || groundingChunks.length === 0) {
          console.warn("[Gemini Service - analyzePlantImage] Falha: Nenhum dado de Grounding foi retornado. A IA pode estar sem acesso à busca.");
        }
      } catch (e) {
         console.error("[Gemini Service - analyzePlantImage] Falha estrutural ao tentar extrair Grounding:", e);
      }

      const sources = groundingChunks
          ? groundingChunks
              .filter((chunk: any) => chunk.web)
              .map((chunk: any) => ({
                uri: chunk.web.uri,
                title: chunk.web.title
              }))
          : [];

      return {
        text: response.text || '',
        sources
      };
    } catch (e) {
      console.error("[Gemini Service - analyzePlantImage] Erro de API:", e);
      return {
         text: 'A busca botânica estendida está temporariamente indisponível. Não foi possível conectar aos bancos de dados globais. Por favor, tente novamente mais tarde.',
         sources: []
      };
    }
  }
}

export const geminiService = new GeminiService();
